/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__validation__model__ValidationStatus;

(function (jove__app__validation__model__ValidationStatus) {
  jove__app__validation__model__ValidationStatus["IMPORTED"] = "imported";
  jove__app__validation__model__ValidationStatus["NOT_STARTED"] = "not_started";
  jove__app__validation__model__ValidationStatus["INVITATION_CREATED"] = "invitation_created";
  jove__app__validation__model__ValidationStatus["DROPOUT"] = "dropout";
  jove__app__validation__model__ValidationStatus["CANCELLED"] = "cancelled";
  jove__app__validation__model__ValidationStatus["IN_PROGRESS"] = "in_progress";
  jove__app__validation__model__ValidationStatus["FAIL"] = "fail";
  jove__app__validation__model__ValidationStatus["SUCCESS"] = "success";
  jove__app__validation__model__ValidationStatus["PAYE_CONTRACTOR"] = "paye_contractor";
})(jove__app__validation__model__ValidationStatus || (jove__app__validation__model__ValidationStatus = {}));